import React, { useState, useCallback, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';

function index({ handleClose, gatewayId }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const { userId } = JSON.parse(sessionStorage.user).user;
  const formModel = {
    addr: '',
    cmd: '',
    payload: {
      tempInterval: 15,
      advInterval: 5,
      startDelay: 0,
    },
    payload1: {
      bytes: '030702',
    },
    payload3: {
      bytes: '030702',
    },
    payload2: {
      version: '1.7.x',
      lowTempAlert: 2.0,
      highTempAlert: 25.0,
      consecutiveTempAlert: 1,
      lifetimeTempAlert: 1,
      startDelay: 8,
      stopDelay: 8,
      ignoreStart: 4,
      btnPressTime: 3,
      startBlinks: 3,
      stopGoodBlinks: 3,
      stopBadBlinks: 5,
      blinkLongMs: 500,
      blinkLongMsOff: 500,
      blinkShortMs: 250,
      blinkSHortMsOff: 250,
      tripDuration: 576,
      lifetimeLowTemp: 0,
      lifetimeHighTemp: 25.0,
    },
  };
  // let
  const [shadowData, setShadowData] = useState([]);
  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const handleInputChange_1 = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleInputChange = useCallback((e) =>
    setFormData({ ...formData, payload: { ...formData.payload, [e.target.name]: e.target.value } })
  );
  const handleInputChange2 = useCallback((e) =>
    setFormData({ ...formData, payload1: { ...formData.payload1, [e.target.name]: e.target.value } })
  );
  const handleInputChange3 = useCallback((e) =>
    setFormData({ ...formData, payload2: { ...formData.payload2, [e.target.name]: e.target.value } })
  );
  const handleInputChange4 = useCallback((e) =>
    setFormData({ ...formData, payload3: { ...formData.payload3, [e.target.name]: e.target.value } })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.cmd === 'reset') {
      shadowData.push({ addr: formData.addr, cmd: formData.cmd, payload: formData.payload });
    }
    if (formData.cmd === 'read') {
      shadowData.push({ addr: formData.addr, cmd: formData.cmd, payload: formData.payload1 });
    }

    if (formData.cmd === 'raw') {
      shadowData.push({ addr: formData.addr, cmd: formData.cmd, payload: formData.payload3 });
    }
    if (formData.cmd === 'alert') {
      shadowData.push({ addr: formData.addr, cmd: formData.cmd, payload: formData.payload2 });
    }
    setFormData({
      addr: '',
      cmd: '',
      payload: {
        tempInterval: 15,
        advInterval: 5,
        startDelay: 0,
      },
      payload1: {
        bytes: '030702',
      },
      payload3: {
        bytes: '030702',
      },
      payload2: {
        version: '1.7.x',
        lowTempAlert: 2.0,
        highTempAlert: 25.0,
        consecutiveTempAlert: 1,
        lifetimeTempAlert: 1,
        startDelay: 8,
        stopDelay: 8,
        ignoreStart: 4,
        btnPressTime: 3,
        startBlinks: 3,
        stopGoodBlinks: 3,
        stopBadBlinks: 5,
        blinkLongMs: 500,
        blinkLongMsOff: 500,
        blinkShortMs: 250,
        blinkSHortMsOff: 250,
        tripDuration: 576,
        lifetimeLowTemp: 0,
        lifetimeHighTemp: 25.0,
      },
    });
    postData(`/device/${gatewayId}/config`, 'POST', { ble_cmds: shadowData });
  };

  const deleteAttribute = (item) => {
    const tempArr = [...shadowData];
    tempArr.splice(
      tempArr.findIndex((a) => a.addr === item.addr && a.cmd === item.cmd),
      1
    );
    setShadowData(tempArr);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      handleClose();
    }

    if (isError) {
    }
  }, [isLoading, isError, data]);

  const handleAddAttributes = () => {
    if (formData.cmd === 'reset') {
      setShadowData((prevArray) => [
        ...prevArray,
        { addr: formData.addr, cmd: formData.cmd, payload: formData.payload },
      ]);
    }
    if (formData.cmd === 'read') {
      setShadowData((prevArray) => [
        ...prevArray,
        { addr: formData.addr, cmd: formData.cmd, payload: formData.payload1 },
      ]);
    }

    if (formData.cmd === 'raw') {
      setShadowData((prevArray) => [
        ...prevArray,
        { addr: formData.addr, cmd: formData.cmd, payload: formData.payload3 },
      ]);
    }
    if (formData.cmd === 'alert') {
      setShadowData((prevArray) => [
        ...prevArray,
        { addr: formData.addr, cmd: formData.cmd, payload: formData.payload2 },
      ]);
    }

    setFormData({
      addr: '',
      cmd: '',
      payload: {
        tempInterval: 15,
        advInterval: 5,
        startDelay: 0,
      },
      payload1: {
        bytes: '030702',
      },
      payload3: {
        bytes: '030702',
      },
      payload2: {
        version: '1.7.x',
        lowTempAlert: 2.0,
        highTempAlert: 25.0,
        consecutiveTempAlert: 1,
        lifetimeTempAlert: 1,
        startDelay: 8,
        stopDelay: 8,
        ignoreStart: 4,
        btnPressTime: 3,
        startBlinks: 3,
        stopGoodBlinks: 3,
        stopBadBlinks: 5,
        blinkLongMs: 500,
        blinkLongMsOff: 500,
        blinkShortMs: 250,
        blinkSHortMsOff: 250,
        tripDuration: 576,
        lifetimeLowTemp: 0,
        lifetimeHighTemp: 25.0,
      },
    });
  };

  return (
    <div
      className="flex justify-center items-center h-full w-full z-50 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-full sm:w-2/4 px-5 pt-4 relative top-0 rounded-2xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-6 right-6 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">Shadow</p>

        <form className="flex flex-wrap" onSubmit={handleSubmit}>
          <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="company" className="block text-parameter w-1/3 text-sm mr-2">
              ADDR
            </label>
            <input
              placeholder="ADDR"
              type="text"
              value={formData.addr}
              name="addr"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange_1}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-4 w-2.25/5 relative">
            <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
              CMD
            </label>
            <input
              placeholder="CMD"
              type="text"
              name="cmd"
              value={formData.cmd}
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange_1}
              list="cmds"
            />
            <datalist id="cmds">
              <option>Select</option>
              <option key="reset">reset</option>
              <option key="read">read</option>
              <option key="raw">raw</option>
              <option key="alert">alert</option>
            </datalist>
          </div>
          {formData.cmd === 'reset' && (
            <>
              <div className="mt-4 w-2.25/5 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  TempInterval
                </label>
                <input
                  placeholder="TempInterval"
                  type="text"
                  value={formData.payload.tempInterval}
                  name="tempInterval"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
              <div className="w-1/10" />
              <div className="mt-4 w-2.25/5 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  AdvInterval
                </label>
                <input
                  placeholder="AdvInterval"
                  type="text"
                  value={formData.payload.advInterval}
                  name="advInterval"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
              <div className="mt-4 w-2.25/5 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StartDelay
                </label>
                <input
                  placeholder="StartDelay"
                  type="text"
                  value={formData.payload.startDelay}
                  name="startDelay"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>
            </>
          )}
          {formData.cmd === 'read' && (
            <div className="mt-4 w-2.25/5 relative">
              <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                Bytes
              </label>
              <input
                placeholder="Bytes"
                type="text"
                value={formData.payload1.bytes}
                name="bytes"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange2}
              />
            </div>
          )}
          {formData.cmd === 'raw' && (
            <div className="mt-4 w-2.25/5 relative">
              <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                Bytes
              </label>
              <input
                placeholder="Bytes"
                type="text"
                value={formData.payload3.bytes}
                name="bytes"
                className="inputLabelText px-4 py-2 focus:outline-none"
                onChange={handleInputChange4}
              />
            </div>
          )}

          {formData.cmd === 'alert' && (
            <>
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  Version
                </label>
                <input
                  placeholder="Version"
                  type="text"
                  value={formData.payload2.version}
                  name="version"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  LowTempAlert
                </label>
                <input
                  placeholder="LowTempAlert"
                  type="text"
                  value={formData.payload2.lowTempAlert}
                  name="lowTempAlert"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  HighTempAlert
                </label>
                <input
                  placeholder="HighTempAlert"
                  type="text"
                  value={formData.payload2.highTempAlert}
                  name="highTempAlert"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              {/* <div className="w-1/10" /> */}
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  ConsecutiveTempAlert
                </label>
                <input
                  placeholder="ConsecutiveTempAlert"
                  type="text"
                  value={formData.payload2.consecutiveTempAlert}
                  name="consecutiveTempAlert"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>

              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  LifetimeTempAlert
                </label>
                <input
                  placeholder="LifetimeTempAlert"
                  type="text"
                  value={formData.payload2.lifetimeTempAlert}
                  name="lifetimeTempAlert"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StartDelay
                </label>
                <input
                  placeholder="StartDelay"
                  type="text"
                  value={formData.payload2.startDelay_1}
                  name="startDelay_1"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StopDelay
                </label>
                <input
                  placeholder="StopDelay"
                  type="text"
                  value={formData.payload2.stopDelay}
                  name="stopDelay"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  IgnoreStart
                </label>
                <input
                  placeholder="IgnoreStart"
                  type="text"
                  value={formData.payload2.ignoreStart}
                  name="ignoreStart"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>

              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  BtnPressTime
                </label>
                <input
                  placeholder="BtnPressTime"
                  type="text"
                  value={formData.payload2.btnPressTime}
                  name="btnPressTime"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              {/* <div className="w-1/10" /> */}
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StartBlinks
                </label>
                <input
                  placeholder="StartBlinks"
                  type="text"
                  value={formData.payload2.startBlinks}
                  name="startBlinks"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StopGoodBlinks
                </label>
                <input
                  placeholder="StopGoodBlinks"
                  type="text"
                  value={formData.payload2.stopGoodBlinks}
                  name="stopGoodBlinks"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  StopBadBlinks
                </label>
                <input
                  placeholder="StopBadBlinks"
                  type="text"
                  value={formData.payload2.stopBadBlinks}
                  name="stopBadBlinks"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  BlinkLongMs
                </label>
                <input
                  placeholder="BlinkLongMs"
                  type="text"
                  value={formData.payload2.blinkLongMs}
                  name="blinkLongMs"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  BlinkLongMsOff
                </label>
                <input
                  placeholder="BlinkLongMsOff"
                  type="text"
                  value={formData.payload2.blinkLongMsOff}
                  name="blinkLongMsOff"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  BlinkShortMs
                </label>
                <input
                  placeholder="BlinkShortMs"
                  type="text"
                  value={formData.payload2.blinkShortMs}
                  name="blinkShortMs"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              {/* <div className="w-1/10" /> */}
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  BlinkSHortMsOff
                </label>
                <input
                  placeholder="BlinkSHortMsOff"
                  type="text"
                  value={formData.payload2.blinkSHortMsOff}
                  name="blinkSblinkSHortMsOffhortMs"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  TripDuration
                </label>
                <input
                  placeholder="TripDuration"
                  type="text"
                  value={formData.payload2.tripDuration}
                  name="tripDuration"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  LifetimeLowTemp
                </label>
                <input
                  placeholder="LifetimeLowTemp"
                  type="text"
                  value={formData.payload2.lifetimeLowTemp}
                  name="lifetimeLowTemp"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
              <div className="w-1/12" />
              <div className="mt-4 w-2/12 relative">
                <label htmlFor="address" className="block text-parameter w-1/3 text-sm mr-2">
                  LifetimeHighTemp
                </label>
                <input
                  placeholder="LifetimeHighTemp"
                  type="text"
                  value={formData.payload2.lifetimeHighTemp}
                  name="lifetimeHighTemp"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange3}
                />
              </div>
            </>
          )}

          <div className="relative flex w-full">
            <img
              src="assets/img/Add.svg"
              className=" left-0 lg:left-0 h-8 mt-4 cursor-pointer"
              alt=""
              onClick={handleAddAttributes}
            />
          </div>

          <div className="w-7/12 flex">
            {shadowData &&
              shadowData.map((item) => (
                <p
                  className="text-black py-1 px-4 h-8 mt-2 rounded-full border cursor-pointer relative"
                  onClick={() => deleteAttribute(item)}
                >
                   <img
          src="assets/img/Close.svg"
          className="absolute -top-1 right-1 h-2 cursor-pointer "
          alt=""
          onClick={() => deleteAttribute(item)}
        />
                  {item.addr}- {item.cmd}
                  {/* {item.join(' - ')} */}
                </p>
              ))}
          </div>
          <div className="w-5/12 relative mb-2 mt-4">
            {isLoading ? (
              <div className="flex text-xs">
                <img src="assets/img/loader.svg" className="w-16 right-28 mx-auto" alt="" />
              </div>
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/2 h-10 text-white bg-btnBg cursor-pointer "
                  style={{ border: '1px solid #16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default index;
